import Icon from '../Icon';
import React from 'react';

const QuickSearchNoHit = (props) => {
  const { title, description } = props;

  return (
    <div className="flex justify-start lg:my-6">
      <div className="flex max-w-[568px] flex-col items-start ">
        {title && <h4 className="h4">{title}</h4>}
        {description && (
          <div
            className="mt-2"
            dangerouslySetInnerHTML={{
              __html: description.value,
            }}
          />
        )}
      </div>
    </div>
  );
};

export default QuickSearchNoHit;
